import { routeName } from 'ember-route-state/utils/route-name.js';

export function routeParentName(route) {
  route = routeName(route);
  if (!route || typeof route !== 'string'
    || route === 'index' || route === 'application'
  ) {
    return undefined;
  }
  const childDot = route.lastIndexOf('.');
  return childDot < 0 ? 'application' : route.substring(0, childDot);
}
